import { ACCESS_ADMIN_VOCABULARIES } from './access-admin.js';
import { MISC_API_VIEWS_VOCABULARIES } from './misc-api-views.js';
import { GOVERNANCE_CONFIG_VIEWS_VOCABULARIES } from './governance-config-views.js';
import { DRIVER_WALLET_VIEWS_VOCABULARIES } from './driver-wallet-views.js';
import { API_CLIENT_COMMON_VOCABULARIES } from './api-client-common.js';
import { OPERATORS_ADMIN_VIEWS_VOCABULARIES } from './operators-admin-views.js';
import { PRICING_PRIVACY_VOCABULARIES } from './pricing-privacy.js';
import { TRUST_REPUTATION_VOCABULARIES } from './trust-reputation.js';
import { RIDE_REQUEST_VIEWS_VOCABULARIES } from './ride-request-views.js';
import { SERVICE_CENTER_VIEWS_VOCABULARIES } from './service-center-views.js';
import { PROBLEM_RIDE_DESK_VOCABULARIES } from './problem-ride-desk.js';
import { PROBLEM_GOVERNED_SETTINGS_VOCABULARIES } from './problem-governed-settings.js';
import { PROBLEM_MONEY_ENGINES_VOCABULARIES } from './problem-money-engines.js';
import { PROBLEM_DESK_FAKE_MIRRORS_VOCABULARIES } from './problem-desk-fake-mirrors.js';
import { FOOD_VIEWS_VOCABULARIES } from './food-views.js';
import { MISC_VIEWS_VOCABULARIES } from './misc-views.js';
import { FINANCE_VIEWS_VOCABULARIES } from './finance-views.js';
import { OPS_VIEWS_VOCABULARIES } from './ops-views.js';
import { PROBLEM_DOMAIN_ENGINES_VOCABULARIES } from './problem-domain-engines.js';
import { MISC_DOMAIN_VIEWS_VOCABULARIES } from './misc-domain-views.js';
import { PROBLEM_SHARED_A_VOCABULARIES } from './problem-shared-a.js';
/** Slice a of the catalog (D577): the domain files this build front owns register here. */
export const SLICE_A = [
    ...ACCESS_ADMIN_VOCABULARIES,
    ...MISC_API_VIEWS_VOCABULARIES,
    ...GOVERNANCE_CONFIG_VIEWS_VOCABULARIES,
    ...DRIVER_WALLET_VIEWS_VOCABULARIES,
    ...API_CLIENT_COMMON_VOCABULARIES,
    ...OPERATORS_ADMIN_VIEWS_VOCABULARIES,
    ...PRICING_PRIVACY_VOCABULARIES,
    ...TRUST_REPUTATION_VOCABULARIES,
    ...RIDE_REQUEST_VIEWS_VOCABULARIES,
    ...SERVICE_CENTER_VIEWS_VOCABULARIES,
    ...PROBLEM_RIDE_DESK_VOCABULARIES,
    ...PROBLEM_GOVERNED_SETTINGS_VOCABULARIES,
    ...PROBLEM_MONEY_ENGINES_VOCABULARIES,
    ...PROBLEM_DESK_FAKE_MIRRORS_VOCABULARIES,
    ...FOOD_VIEWS_VOCABULARIES,
    ...MISC_VIEWS_VOCABULARIES,
    ...FINANCE_VIEWS_VOCABULARIES,
    ...OPS_VIEWS_VOCABULARIES,
    ...PROBLEM_DOMAIN_ENGINES_VOCABULARIES,
    ...MISC_DOMAIN_VIEWS_VOCABULARIES,
    ...PROBLEM_SHARED_A_VOCABULARIES,
];
//# sourceMappingURL=slice-a.js.map